import React from 'react';
import * as styles from './renderHighlight.module.scss';

const EM_TAG_REGEX = /<\/?em>/g;

export const stripHighlight = (text: string) => text.replace(EM_TAG_REGEX, '');

export default function renderHighlight(text: string) {
  if (!text) return '';
  return text.split(EM_TAG_REGEX).map((part, i) => {
    if (i % 2 === 0) return part;
    return (
      // eslint-disable-next-line react/no-array-index-key
      <em className={styles.searchHighlight} key={i}>
        {part}
      </em>
    );
  });
}
